'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPYEARSTART = exports.REPORTING_YEAR_START_DAY = exports.OBS_TYPE_STRING = exports.OBS_TYPE_NUMERICAL_STRING = exports.OBS_TYPE_NUMBER = exports.V8_SDMX_JSON = exports.DEFAULT_MAJOR_ATTRIBUTES = exports.DIMENSION_DISPLAY_PARTS = exports.DEFAULT_REJECTED_SUBTITLE_IDS = exports.DEFAULT_REJECTED_UPR_VALUES_IDS = exports.DEFAULT_UPR_IDS = exports.FREQ_M = exports.FREQ_Q = exports.FREQ_S = exports.FREQ_A = exports.TYPES = exports.VALUES = exports.PERCENT = exports.CHORO = exports.STACKED_ROW = exports.STACKED_BAR = exports.V_SYMBOL = exports.H_SYMBOL = exports.TIMELINE = exports.SCATTER = exports.ROW = exports.BAR = undefined;
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _TYPES;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BAR = exports.BAR = 'BarChart';
var ROW = exports.ROW = 'RowChart';
var SCATTER = exports.SCATTER = 'ScatterChart';
var TIMELINE = exports.TIMELINE = 'TimelineChart';
var H_SYMBOL = exports.H_SYMBOL = 'HorizontalSymbolChart';
var V_SYMBOL = exports.V_SYMBOL = 'VerticalSymbolChart';
var STACKED_BAR = exports.STACKED_BAR = 'StackedBarChart';
var STACKED_ROW = exports.STACKED_ROW = 'StackedRowChart';
var CHORO = exports.CHORO = 'ChoroplethChart';
var PERCENT = exports.PERCENT = 'percent';
var VALUES = exports.VALUES = 'values';
var TYPES = exports.TYPES = (_TYPES = {}, (0, _defineProperty3.default)(_TYPES, BAR, BAR), (0, _defineProperty3.default)(_TYPES, ROW, ROW), (0, _defineProperty3.default)(_TYPES, SCATTER, SCATTER), (0, _defineProperty3.default)(_TYPES, TIMELINE, TIMELINE), (0, _defineProperty3.default)(_TYPES, H_SYMBOL, H_SYMBOL), (0, _defineProperty3.default)(_TYPES, V_SYMBOL, V_SYMBOL), (0, _defineProperty3.default)(_TYPES, STACKED_BAR, STACKED_BAR), (0, _defineProperty3.default)(_TYPES, STACKED_ROW, STACKED_ROW), (0, _defineProperty3.default)(_TYPES, CHORO, CHORO), _TYPES);
var FREQ_A = exports.FREQ_A = 'annual';
var FREQ_S = exports.FREQ_S = 'semesterly';
var FREQ_Q = exports.FREQ_Q = 'quarterly';
var FREQ_M = exports.FREQ_M = 'monthly';
var DEFAULT_UPR_IDS = exports.DEFAULT_UPR_IDS = {
  U: ['UNIT', 'UNIT_MEASURE', 'UNIT_MEAS', 'UNITS'],
  P: ['UNIT_MULT', 'POWERCODE', 'POWER', 'MAGNITUDE', 'SCALE'],
  R: ['REF_PERIOD', 'REFERENCEPERIOD', 'BASE_PER']
};
var DEFAULT_REJECTED_UPR_VALUES_IDS = exports.DEFAULT_REJECTED_UPR_VALUES_IDS = {
  U: [],
  P: ['0'],
  R: []
};
var DEFAULT_REJECTED_SUBTITLE_IDS = exports.DEFAULT_REJECTED_SUBTITLE_IDS = ['_L', '_T', '_Z'];
var DIMENSION_DISPLAY_PARTS = exports.DIMENSION_DISPLAY_PARTS = {
  DESCRIPTION: 'description',
  CODE: 'code',
  BOTH: 'both'
};
var DEFAULT_MAJOR_ATTRIBUTES = exports.DEFAULT_MAJOR_ATTRIBUTES = {
  DECIMALS: {
    ID: 'DECIMALS',
    ROLE: 'DECIMALS'
  },
  SCALE: {
    ID: 'SCALE'
  }
};
var V8_SDMX_JSON = exports.V8_SDMX_JSON = "application/vnd.sdmx.data+json;version=1.0.0-wd";
var OBS_TYPE_NUMBER = exports.OBS_TYPE_NUMBER = 'OBS_TYPE_NUMBER';
var OBS_TYPE_NUMERICAL_STRING = exports.OBS_TYPE_NUMERICAL_STRING = 'OBS_TYPE_NUMERICAL_STRING';
var OBS_TYPE_STRING = exports.OBS_TYPE_STRING = 'OBS_TYPE_STRING';
var REPORTING_YEAR_START_DAY = exports.REPORTING_YEAR_START_DAY = 'REPORTING_YEAR_START_DAY';
var REPYEARSTART = exports.REPYEARSTART = 'REPYEARSTART';